// utils/apiHelpers.ts
import axios from 'axios';

export const getCompanySettings = async () => {
  const res = await axios.get('https://qbo.omnivistaweb.com/api/settings/company');
  return res.data; // { logo: '...', company_name: '...' }
};